import styled from 'styled-components';

export const ScheduledMessagesDrawerContainer = styled.div`
  background-color: var(--neutral-0);
  box-shadow: inset 4px 0px 12px rgba(0, 0, 0, 0.1);
  width: 328px;
  height: 100%;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 700px) {
    width: 100%;
    position: absolute;
    left: 0;
    top: 140px;
    z-index: 999;
  }
`

export const ScheduledMessagesDrawerFooter = styled.footer`
  padding: var(--spacement-medium) var(--spacement-xxlarge);

  & button {
    text-align: left;
    line-height: var(--spacement-medium);
    padding-block: var(--spacement-default);
  }

  & svg path {
    fill: #ffffff;
  }
`

export const ScheduledMessages = styled.div`
  padding-top: var(--spacement-default);
  flex: 1;
  overflow: auto;
  padding-inline: var(--spacement-default);
  padding-left: var(--spacement-medium);

  @media screen and (max-width: 828px) {
    padding-left: 0;
  }
`
